import { Feature, useFeatureGate } from '@/hooks/useFeatureGate';
export const getIsCodeCheckMode = () => useFeatureGate(Feature.AICheckMode).aiCheckMode;
export function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    const stack = [];
    const keys = [];
    if (!cycleReplacer) {
        // eslint-disable-next-line no-param-reassign
        cycleReplacer = function (key, value) {
            if (stack[0] === value)
                return '[Circular ~]';
            return `[Circular ~.${keys.slice(0, stack.indexOf(value)).join('.')}]`;
        };
    }
    return function (key, value) {
        if (stack.length > 0) {
            const thisPos = stack.indexOf(this);
            if (thisPos !== -1) {
                stack.splice(thisPos + 1);
                keys.splice(thisPos, Infinity, key);
            }
            else {
                stack.push(this);
                keys.push(key);
            }
            if (stack.includes(value)) {
                // eslint-disable-next-line no-param-reassign
                value = cycleReplacer.call(this, key, value);
            }
        }
        else {
            stack.push(value);
        }
        return replacer ? replacer.call(this, key, value) : value;
    };
}
export function ignoreCycle(obj) {
    try {
        return JSON.parse(stringify(obj));
    }
    catch (error) {
        console.error('ignoreCycle fail', error);
        return undefined;
    }
}
